import { formatAddress } from './formatAddress';

import { IAddressInfo } from '~/api/IAddressInfo';

export const getAlertAddress = (address?: Partial<IAddressInfo>) => formatAddress(address, false, false, false);
